<p>formly-mixed-schema-type works!</p>
